import { styled } from "@mui/material";

interface TrackBadgeProps {
  showCursorOnHover?: boolean;
}

export const TrackBadge = styled("div")(({ showCursorOnHover }: TrackBadgeProps) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  marginLeft: "10px",
  cursor: showCursorOnHover ? "pointer" : "normal",
}));

export const TrackContainer = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  width: "100%",
}));
